import React, { useContext } from 'react'
import styles from './WorkingStatus.module.css'
import { ChoicesButton } from '../../../Common/CtaButton/ChoicesButton'
import { BackButton } from '../../../Common/CtaButton/BackButton'
import { StepContext, StepIndexContext } from '../../StepContainer'
import { useAbTestGtm } from '../../../../hooks/useAbTestGtm'

export const WorkingStatus = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const { testPattern } = useContext(StepContext)
    const stepIndex = useContext(StepIndexContext)
    // DEV-3482: Bではこのステップが1問目ではないため戻る先がある（A/Cは1問目なので出さない）。
    // 他ステップの戻るボタンは FormTitle が持つが、このステップは見出しを自前で描いている
    const showBackButton = stepIndex > 0

    return (
        <div className={styles.wrapper}>
            <div>
                <div className={showBackButton ? styles.titleWithBack : ''}>
                    {showBackButton && (
                        <BackButton
                            dataClickLabel={dataClickLabel(
                                'EF_StepForm_現在の状況-戻る'
                            )}
                        />
                    )}
                    <h1
                        data-view-label={dataViewLabel(
                            'EF_StepForm_現在の状況'
                        )}
                        className={styles.titleText}
                    >
                        現在の状態はどうですか？
                    </h1>
                </div>
                <div className={styles.selectionWrapper}>
                    <ChoicesButton
                        imageSrc="/foodslaboEf/img/step1/people-cook.png"
                        imageAlt="料理人イラスト"
                        text="在職中"
                        formKey="situation"
                        formValue="tenure"
                        displayFormKey="situation"
                        displayFormValue="在職中"
                        dataClickLabel={dataClickLabel(
                            'EF_StepForm_現在の状況-在職中'
                        )}
                    />
                    <ChoicesButton
                        imageSrc="/foodslaboEf/img/step1/people-normal.png"
                        imageAlt="男性イラスト"
                        text="離職中"
                        formKey="situation"
                        formValue="resignation"
                        displayFormKey="situation"
                        displayFormValue="離職中"
                        dataClickLabel={dataClickLabel(
                            'EF_StepForm_現在の状況-離職中'
                        )}
                    />
                </div>
                <div>
                    <p className={styles.descriptionText}>
                        入力した情報は応募先の企業以外全て非公開です
                    </p>
                </div>
                {/* DEV-3482: Cはこのステップが1問目。Bは1問目のメールアドレス側に同じ導線がある */}
                {testPattern === 'C' && (
                    <p className={styles.loginText}>
                        <a
                            href={'/login'}
                            data-click-label={dataClickLabel(
                                'EF_StepForm_現在の状況-会員登録済み'
                            )}
                        >
                            会員登録済みの方はこちら
                        </a>
                    </p>
                )}
            </div>
        </div>
    )
}
